import React, { FunctionComponent, ReactNode, useEffect } from 'react';
import { ThirdwebProvider } from 'thirdweb/react';

import DAppProvider from '@context/providers/DAppProvider';

import { initAmplitude } from '../helpers';

interface Props {
  children: ReactNode;
}

const WrapRootElement: FunctionComponent<Props> = ({ children }) => {
  useEffect(() => {
    const initializeAmplitude = async () => {
      await initAmplitude();
    };
    initializeAmplitude();
  }, []);

  return (
    <DAppProvider>
      <ThirdwebProvider>{children}</ThirdwebProvider>
    </DAppProvider>
  );
};

export default WrapRootElement;
